import type { Translations } from "../../i18n/en";

/**
 * A PMS's display name from its provider type, or "PMS" where none is known.
 * A partial `t`, as the test harnesses hand components, names none.
 */
export function pmsDisplayName(t: Translations, providerType: string): string {
    const providers = (t.pms as { providers?: Record<string, { displayName?: string }> } | undefined)?.providers;
    return providers?.[providerType]?.displayName ?? "PMS";
}
